"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVideo = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _templateObject;
var StyledVideo = exports.StyledVideo = _styledComponents["default"].video(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  ", "\n"])), function (props) {
  return props.sourceType === _constants.SCREEN_PRESENTER ? 'object-fit: contain !important' : 'object-fit: cover';
});